var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6229 0.390027C16.12 -0.112817 15.3077 -0.112817 14.8049 0.390027L8.5 6.68203L2.19511 0.377133C1.69226 -0.125711 0.879977 -0.125711 0.377133 0.377133C-0.125711 0.879977 -0.125711 1.69226 0.377133 2.19511L6.68203 8.5L0.377133 14.8049C-0.125711 15.3077 -0.125711 16.12 0.377133 16.6229C0.879977 17.1257 1.69226 17.1257 2.19511 16.6229L8.5 10.318L14.8049 16.6229C15.3077 17.1257 16.12 17.1257 16.6229 16.6229C17.1257 16.12 17.1257 15.3077 16.6229 14.8049L10.318 8.5L16.6229 2.19511C17.1128 1.70516 17.1128 0.879978 16.6229 0.390027Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.b6a6e53ecfeb51b6d9b2968333985e52.svg";
export { ForwardRef as ReactComponent };